import React, { useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import DelBox from '../comps/DelBox';
import AddDoctor from '../models/AddDoctor';
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';

const Doctors = () => {
  const [formData, setFormData] = useState({
    l1: [],
    cats: [],
    cat_type: 'doctor',
    search_key: '',
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
    per_page: 10,
    total_rows: 0,
  });

  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [loading, setLoading] = useState(false);

  const getSpecialityName = (spec) => {
    if (spec === null || spec === undefined || spec === '') return '';
    if (typeof spec === 'string' && !/^\d+$/.test(spec)) return spec;
    const idStr = String(spec);
    const cats = Array.isArray(formData.cats) ? formData.cats : [];
    const found = cats.find(c =>
      String(c.cat_id ?? c.id ?? c.value ?? c.key ?? '').toLowerCase() === idStr.toLowerCase()
    );
    if (found) {
      return (found.cat_name ?? found.name ?? found.title ?? found.label ?? String(spec)).toString();
    }
    return String(spec);
  };

  const renderDesignationAndSpeciality = (doc = {}) => {
    const designation = (doc?.doc_designation ?? '').toString().trim();
    const specialityRaw = doc?.doc_specality ?? '';
    const speciality = getSpecialityName(specialityRaw).toString().trim();
    if (designation) return speciality ? `${designation} (${speciality})` : designation;
    return speciality;
  };

  const renderRegNo = (item = {}) => {
    return (
      item?.doc?.doc_reg_number
      ?? item?.doc?.doc_reg_no
      ?? item?.doc_reg_number
      ?? item?.registration_no
      ?? item?.reg_no
      ?? (item?.user_id ? `SDC000101${item.user_id}` : '')
    );
  };

  const fetchCats = async () => {
    try {
      const fd0 = new FormData();
      fd0.append('cat_type', "speciality");
      fd0.append('page_no', "none");
      fd0.append('par_by', 1 + "");
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (resp?.data?.status && Array.isArray(resp.data.records)) {
        setFormData(prev => ({ ...prev, cats: resp.data.records }));
      }
    } catch (err) {
      console.error('fetchCats error', err);
    }
  };

  const initData = async (page = null) => {
    try {
      setLoading(true);
      const storedData = sessionStorage.getItem("ldata");
      const userData = storedData ? JSON.parse(storedData) : null;
      const roleId = userData?.role_id;
      setIsAdmin(roleId === 1 || roleId === "1");
      if (!storedData) {
        setFormData(prev => ({ ...prev, l1: [] }));
        setLoading(false);
        return;
      }

      await fetchCats();

      const pageNo = (page !== null ? page : formData.page_no);

      const fd = new FormData();
      fd.append('type', formData.cat_type + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('page_no', pageNo + "");
      fd.append('user_cre_by', 1 + "");

      const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response?.data?.status) {
        const records = Array.isArray(response.data.records) ? response.data.records : [];

        const normalized = records.map(item => ({
          ...item,
          doc: item && typeof item.doc === 'object' && item.doc !== null
            ? item.doc
            : { doc_fees: 0, doc_degree: '', doc_designation: '', doc_specality: '' }
        }));

        setFormData(prev => ({ ...prev, l1: normalized, page_no: pageNo, total_rows: response.data.total_rows ?? normalized.length }));
      } else {
        setFormData(prev => ({ ...prev, l1: [], total_rows: 0 }));
      }
    } catch (err) {
      console.error("initData error:", err);
      toast.error("Failed to load doctors");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("ldata");
    if (stored) setLdata(JSON.parse(stored));
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const delItem = async (item) => {
    if (!item || !item.user_id) return;
    try {
      const fd = new FormData();
      fd.append('user_id', item.user_id + "");
      const response = await axios.post(AppConst.BASE_URL + AppConst.delUserUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response?.data?.status) {
        toast.success("Doctor deleted successfully");
        initData();
      } else {
        toast.error("Delete failed");
      }
    } catch (err) {
      console.error("Delete failed:", err);
      toast.error("Delete failed");
    }
  };

  const handleAddDepart = () => {
    setFormData(prev => ({ ...prev, page_no: 0 }));
    initData();
  };

  const filteredList = useMemo(() => {
    const list = Array.isArray(formData.l1) ? formData.l1 : [];
    const q = (formData.search_key ?? "").trim().toLowerCase();
    if (!q) return list;
    return list.filter(item => {
      const reg = `${item.user_id}`.toLowerCase();
      const nm = `${item.fname}`.toLowerCase();
      return reg.includes(q) || nm.includes(q);
    });
  }, [formData.l1, formData.search_key]);

  const columns = [
    {
      name: '',
      width: '48px',
      cell: (row) => <input type="checkbox" />,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Reg. No.',
      selector: row => renderRegNo(row),
      sortable: true,
      grow: 0.6,
      width: '150px',
    },
    {
      name: 'Name',
      selector: row => row.fname ?? '',
      sortable: true,
      wrap: true,
    },
    {
      name: 'OPD Fees',
      selector: row => Number(row.doc?.doc_fees ?? 0).toFixed(2),
      sortable: true,
      right: true,
      grow: 0.6,
    },
    {
      name: 'Degree',
      selector: row => row.doc?.doc_degree ?? '',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Designation',
      selector: row => renderDesignationAndSpeciality(row.doc),
      sortable: true,
      wrap: true,
      grow: 1.6,
    },
    {
      name: 'Contact',
      selector: row => row.mobile ?? '',
      sortable: true,
      grow: 0.9,
    },
    {
      name: 'Address',
      selector: row => [row.address_line1, row.address_line2, row.city, row.pincode].filter(Boolean).join(', '),
      wrap: true,
      grow: 2,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div className="hstack gap-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={(e) => {
              e.preventDefault();
              setEditItem(row);

              // small delay to let AddDoctor receive the prop and populate its fields, then show modal
              setTimeout(() => {
                const modalEl = document.getElementById("showModal");
                if (modalEl && typeof window !== "undefined" && window.bootstrap && window.bootstrap.Modal) {
                  try {
                    const inst = window.bootstrap.Modal.getOrCreateInstance(modalEl);
                    inst.show();
                  } catch (err) {
                    // fallback to hidden button click
                    const el = document.getElementById("addbt453");
                    if (el) el.click();
                  }
                } else {
                  const el = document.getElementById("addbt453");
                  if (el) el.click();
                }
              }, 80);
            }}
          >
            <i className="ri-pencil-fill fs-16 me-1"></i> Edit
          </button>

          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={(e) => {
              e.preventDefault();
              delItem(row);
            }}
          >
            <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '220px',
    }
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Doctors</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button id="addbt453" style={{ display: "none" }} type="button" className="btn btn-success add-btn"
                        data-bs-toggle="modal" data-bs-target="#showModal">
                      </button>

                      <button type="button" className="btn btn-success add-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setEditItem(null);
                          // open modal via bootstrap API after tiny delay
                          setTimeout(() => {
                            const modalEl = document.getElementById("showModal");
                            if (modalEl && typeof window !== "undefined" && window.bootstrap && window.bootstrap.Modal) {
                              try {
                                const inst = window.bootstrap.Modal.getOrCreateInstance(modalEl);
                                inst.show();
                              } catch (err) {
                                const el = document.getElementById("addbt453");
                                if (el) el.click();
                              }
                            } else {
                              const el = document.getElementById("addbt453");
                              if (el) el.click();
                            }
                          }, 60);
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Doctor
                      </button>

                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row g-3">
                    <div className="col-xxl-5 col-sm-6">
                      <div className="search-box">
                        <input className="form-control search" placeholder="Search by name..."
                          type="text" name="search_key" onChange={handleChange} value={formData.search_key} />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div>
                  <div className="table-responsive table-card mb-1">
                    <DataTable
                      columns={columns}
                      data={filteredList}
                      progressPending={loading}
                      pagination
                      paginationPerPage={formData.per_page}
                      paginationRowsPerPageOptions={[5, 10, 20, 50]}
                      highlightOnHover
                      dense={false}
                      noHeader
                      defaultSortFieldId={2}
                      responsive
                    />
                  </div>
                </div>

                <AddDoctor item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doctors;
